import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M29.6201 4.06996C32.4201 7.21996 35.0201 14.75 31.6901 29.99C28.3601 45.23 15.7601 62.0799 4.3501 53.6799C4.3501 53.6799 10.9501 54.69 11.1001 42.08C11.2601 29.46 10.6301 15.71 15.5901 7.40004C20.5501 -0.909964 27.1601 1.29996 29.6201 4.06996Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.63013 54.62C6.63013 54.62 13.5201 55.45 15.6501 45.33C19.2101 28.37 17.2901 8.18997 25.2701 3.83997C25.2701 3.83997 28.2501 8.33993 27.0601 24.1799C26.2701 34.6999 20.4001 57.12 8.94012 55.48"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M25.2701 3.83997C25.2701 3.83997 14.6801 4.03004 14.2401 32.92C14.0101 48.29 11.2701 54.02 7.13013 54.13"
        stroke={outline}
        strokeMiterlimit="10"
      />
    </g>
  )
}
